<template>
    <span class="link-select-text">
        {{showValue}}
    </span>
</template>

<script>
    export default {
        name: "link-select-text",
        props: {
            data: {type: Array},
            labelKey: {},
            valKey: {},
            val: {},
        },
        computed: {
            showValue() {
                if (!this.data || this.data.length === 0 || this.val == null) return null
                switch (this.$lv.$utils.typeOf(this.val)) {
                    case 'array':
                        return this.data.reduce((ret, item) => {
                            this.val.indexOf(item[this.valKey]) > -1 && ret.push(item[this.labelKey])
                            return ret
                        }, []).join(',')
                    case 'string':
                        return this.data.reduce((ret, item) => item[this.valKey] === this.val ? item[this.labelKey] : ret, '')
                    default :
                        return null
                }
            },
        },
    }
</script>
